module.exports = __webpack_public_path__ + "static/media/search.3d9d4f0b.svg";